import React from 'react';
import PropTypes from 'prop-types';
import { useOptimizelyTrack } from 'reaxl-optimizely';

import {
    Link,
    ListColumns,
    Modal,
    ModalBody,
    ModalHeader,
    ModalTitle,
} from 'reaxl';

import { callToActionAnalytics } from '@/analytics';
import { useVehicleSearch } from '@/contexts/VehicleSearchContext';

const getMakeSeoURL = (name = '') => `${name.replace(/\s/gi, '-')}`;

const getBaseHref = (listingType) => {
    if (listingType === 'new') {
        return 'cars-for-sale/new-cars/';
    } if (listingType === 'certified') {
        return 'cars-for-sale/certified-cars/';
    }
    return 'cars-for-sale/';
};

const getListItems = (makes, listingType, optimizelyTrack) => {

    const handleClick = (event, makeName) => {
        callToActionAnalytics.fireBrowsByMakeClick(event, { co_txt_url: makeName, makeSelection: true, pageType: 'homepage' });
        optimizelyTrack('hp_to_srp_conversion');
    };

    const baseHref = getBaseHref(listingType);

    return makes.map((make) => {

        const {
            makeDescription,
            makeCode,
        } = make;

        const makeSeoUrl = getMakeSeoURL(makeDescription);
        const href = `${baseHref}${makeSeoUrl}`.toLowerCase();

        return (
            <Link
                key={makeCode}
                href={`https://www.autotrader.com/${href}`}
                data-value={makeCode}
                rel="nofollow"
                onClick={(e) => handleClick(e, makeDescription)}
            >
                {makeDescription}
            </Link>
        );
    });
};

const BrowseByMakeModal = React.memo(({
    listingType = '',
    showModal,
    showHideToggleModalCallback = () => {},
}) => {
    const { vehicleMakes } = useVehicleSearch();
    const optimizelyTrack = useOptimizelyTrack();
    return (
        <Modal
            dialogClassName="browseByMakeModal"
            show={showModal}
            onHide={showHideToggleModalCallback}
            bsSize="large"
            eventId="browse-make"
        >
            <ModalHeader closeButton>
                <ModalTitle className="text-center text-size-600">
                    Browse By Make
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <ListColumns
                    ulClass="list-unstyled"
                    xs={2}
                    sm={4}
                    md={5}
                    lg={6}
                    items={getListItems(vehicleMakes, listingType, optimizelyTrack)}
                />
            </ModalBody>
        </Modal>
    );
});

BrowseByMakeModal.propTypes = {
    listingType: PropTypes.string,
    showModal: PropTypes.bool,
    showHideToggleModalCallback: PropTypes.func,
};

export default BrowseByMakeModal;
